"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeHeatFilterScoreBatchDTO = exports.decodeHeatFilterScoreBatchModelFromDTO = void 0;
var model_1 = require("./model");
Object.defineProperty(exports, "decodeHeatFilterScoreBatchModelFromDTO", { enumerable: true, get: function () { return model_1.decodeHeatFilterScoreBatchModelFromDTO; } });
Object.defineProperty(exports, "encodeHeatFilterScoreBatchDTO", { enumerable: true, get: function () { return model_1.encodeHeatFilterScoreBatchDTO; } });
//# sourceMappingURL=index.js.map